import { NewCombo } from '@features/Paywall/widgets/subscription-card/new-combo';
import type { TpStripeSubscription } from '@features/Stripe/types';

export const ErrorModalPlans = ({
  noMoneyPlan,
  wasTried,
  planAtom,
  selectPlanHandler,
  handlePlanSelect,
  subscriptionAgreementChecked,
  inputIdPrefix,
}: {
  noMoneyPlan: TpStripeSubscription;
  wasTried: boolean;
  planAtom: any;
  selectPlanHandler: (id: string) => void;
  handlePlanSelect: any;
  subscriptionAgreementChecked: any;
  inputIdPrefix: string | undefined;
  currencyReplacer: (currency: string, defaultSymbol?: string | null) => string;
}) => (
  <NewCombo
    plan={noMoneyPlan}
    wasPaymentTried={wasTried}
    isCardSelected={planAtom.priceId === noMoneyPlan.id}
    onSelectPlan={selectPlanHandler}
    handlePlanSelect={handlePlanSelect}
    getPlanDisabled={!subscriptionAgreementChecked}
    inputIdPrefix={inputIdPrefix}
  />
);
